import { render } from "./myportfolio.vue?vue&type=template&id=5a040c4a&scoped=true"
import script from "./myportfolio.vue?vue&type=script&lang=js"
export * from "./myportfolio.vue?vue&type=script&lang=js"

import "./myportfolio.vue?vue&type=style&index=0&id=5a040c4a&scoped=true&lang=css"

import exportComponent from "D:\\Creations\\portfolio backUp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a040c4a"]])

export default __exports__